import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {VehicleType} from "../../../commons/types/vehicle.type";
import {$accountFactory} from "../../../account/$account.factory";
import {CoordinationsAlerts} from "../../services/coordinations-alerts.service";
import {CoordinationRequests} from "../../services/coordinations-requests.service";

export class createNewCoordinationCtrl implements IController {


  private loading: boolean;
  private file: any;
  private packageTypes: any;
  private timeSlots: any;
  private daysSelection: any;
  private minDate: any;
  private payload: any;
  private vehicleTypesRef:VehicleType [];
  private configTimeZone: string;

  /* @ngInject */
  constructor(private commonsConstants, private CoordinationConstants,
              private $account: $accountFactory, private $state, private $filter, private $coordinations, private coordinationRequests: CoordinationRequests,
              private moment, private $log, private coordinationsAlerts: CoordinationsAlerts, private splitService) {
    this.vehicleTypesRef = Object.values(VehicleType);
  }

  $onInit() {
    this.configTimeZone = this.splitService.getTimeZone();

    // Sending time with start/end day:
    const today = this.moment().startOf('day');
    const notAfter = this.moment().add(3, 'day').endOf('day');

    // The older version (Doesn't consider timeZone):
    // const today = this.moment().startOf('day').toDate();
    // const notAfter = this.moment().add(3, 'day').endOf('day').toDate();

    this.loading = false;

    this.packageTypes = this.commonsConstants.packageTypes;
    this.timeSlots = this.CoordinationConstants.timeSlots;
    this.daysSelection = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    this.minDate = today;
    this.payload = {
      slaNotBefore: today,
      slaNotAfter: notAfter,
      timeSlots: [],
      days: [],
      ownerDetails: {},
      ownerId: null,
      serviceAreaList: null,
      packageList: {
        items: []
      }
    };
  };

  /////////////////////////////////////////////////////////////////////

  // ******************************
  // External methods
  // ******************************

  onSelectAccount(accountId) {
    if (!accountId) {
      this.payload.ownerId = null;
      this.payload.ownerDetails = {}
    } else {
      this.payload.ownerId = accountId;
      this.$account(accountId).$asyncValue()
        .then((account) => {
          this.payload.ownerDetails = {
            name: account.name,
            phoneNumber: this.$filter('bringozPhone')(account.phoneNumber),
            address: account.address
          }
        })
        .catch((error) => {
          this.$log.error('Failed to get account, ' +
            'createNewCoordination@onSelectAccount', error)
        })
    }
  }

  onAddressChange(address) {
    if (!address || _.isEmpty(address)) {
      _.unset(this.payload.ownerDetails, 'address');
    } else {
      this.payload.ownerDetails.address = address;
    }
  }

  onMinDateChange(selectedDate) {
    if (selectedDate > this.payload.slaNotAfter) {
      this.payload.slaNotAfter = selectedDate;
    }
  }

  onStartDateChange(selectedDate) {
    this.payload.slaNotBefore = selectedDate;
    if (selectedDate > _.get(this.payload, 'slaNotAfter')) {
      this.payload.slaNotAfter = selectedDate;
    }
  }

  onEndDateChange(selectedDate) {
    this.payload.slaNotAfter = selectedDate;
    if (selectedDate < _.get(this.payload, 'slaNotBefore')) {
      this.payload.slaNotBefore = selectedDate;
    }
  }

  onSelectServiceAreas(serviceAreas) {
    this.payload.serviceAreaList = serviceAreas;
  }

  onAddFile(file) {
    this.file = file;
    if (file) {
      this.loading = true;
      this.coordinationRequests.uploadCoordinationExcel(file)
        .then((res) => {
          this.payload.serviceTemplateList = res.data;
        })
        .catch((error) => {
          this.$log.error('Failed to upload excel to server, ' +
            'createNewCoordination@onAddFile' + error)
        })
        .finally(() => {
          this.loading = false;
        })
    }
  }

  submitForm(form) {
    form.$setSubmitted(true);
    if (form.$valid) {
      const payload = angular.copy(this.payload);

      if (payload.ownerDetails.phoneNumber) {
        payload.ownerDetails.phoneNumber = this.$filter('bringozPhonePrefix')(payload.ownerDetails.phoneNumber)
      }

      _.set(payload, 'packageList', []);
      payload.packageList.push(this.payload.packageList);

      // The payload that is sent
      payload.slaNotBefore = this.splitService.getStartDayTimestamp(this.payload.slaNotBefore);
      payload.slaNotAfter = this.splitService.getEndDayTimestamp(this.payload.slaNotAfter);

      this.doUpdate(payload);
    }

  }

  // ******************************
  //        Internal methods
  // ******************************

  doUpdate(payload) {
    this.loading = true;
    this.$coordinations().$put(payload)
      .then((payload) => {
        this.loading = false;
        this.$state.go('coordinations');
        this.coordinationsAlerts.createCoordinationSuccess();
      })
      .catch((error) => {
        this.loading = false;
        this.coordinationsAlerts.createCoordinationError();
        this.$log.error('Failed to create new coordination , ' +
          'createNewCoordination@doUpdate \n' + error);
      })
  }

}

angular
  .module('bringoz.admin.coordinations')
  .component('createNewCoordination', {
    bindings: {},
    template: require('./create-new-coordination.html').default,
    controller: createNewCoordinationCtrl
  });

